import {
  createUserFileRequest,
  fetchUserFileRequest,
  editUserFileRequest,
  CreateUserFileRequestType,
} from 'api';
import { setAuthLoading, setUserFile } from 'state/actions';
import { TypedDispatch } from 'state/types';

export const fetchUserFile =
  (inspectionFileId: string) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await fetchUserFileRequest(inspectionFileId);

      dispatch(setUserFile(response?.data));

      return response?.data;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const createUserFile =
  (data: CreateUserFileRequestType) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await createUserFileRequest(data);

      return response?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const editUserFile =
  (userFile: CreateUserFileRequestType) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await editUserFileRequest(userFile);

      return response;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };
